import { clientPath, lpRequest, refId, userId } from '../../../../core/utils/lp-backend';

const byFullName = (a: any, b: any) =>
  `${a.firstname ?? ''} ${a.lastname ?? ''}`.localeCompare(
    `${b.firstname ?? ''} ${b.lastname ?? ''}`
  );

/**
 * A listed loop-pro user in cb's shape. The list carries hub and region access as references only, and
 * `permissions_id` (the reports feature's key) is the `client-users` login id, `user_ref`.
 */
export const toCbListedUser = (user: any): any => {
  const permissions = user.permissions || {};
  const dos = permissions.dos || {};

  return {
    ...user,
    permissions: {
      ...permissions,
      dos: {
        hubs: (dos.hubs || []).map((hub: any) => ({ id: refId(hub) })),
        regions: (dos.regions || []).map((region: any) => ({ id: refId(region) }))
      },
      // The list answers report ids; cb answered report objects, which the reports screens compare by `id`.
      reports: (permissions.reports || []).map((report: any) =>
        typeof report === 'string' ? { id: report } : report
      ),
      permissions_id: refId(user.user_ref) || ''
    }
  };
};

/**
 * `GET /client/:cid/users`, in name order, with each user's `email` and `image` joined from
 * `GET /client/:cid/users/contacts`. The client's superuser (Loop Admin, `do-not-delete@loop.co.za`) is hidden from
 * everyone but itself, as cb-client-admin-api did.
 */
export const getUsers = async (): Promise<any[]> => {
  const [users, contacts] = await Promise.all([
    lpRequest('GET', clientPath('/users')),
    lpRequest('GET', clientPath('/users/contacts'))
  ]);
  const contactOf = new Map((contacts || []).map((contact: any) => [contact.id, contact]));
  const me = userId();

  return (users || [])
    .filter((user: any) => !user.permissions?.superuser || refId(user.user_ref) === me)
    .map((user: any) => {
      const contact: any = contactOf.get(user.id) || {};
      return toCbListedUser({
        ...user,
        email: contact.email ?? undefined,
        image: contact.image ?? undefined
      });
    })
    .sort(byFullName);
};
